module.exports = __webpack_public_path__ + "img/icon-group.e220e3bb.svg";